import * as React from "react"
import type { SVGProps } from "react"
const SvgReviewSourceAppStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      fill="currentColor"
      d="m50.25 23.795 2.025-3.5c1.25-2.187 4.038-2.925 6.225-1.675 2.188 1.25 2.925 4.037 1.675 6.225L40.663 58.62h14.112c4.575 0 7.138 5.375 5.15 9.1H18.55A4.535 4.535 0 0 1 14 63.17a4.535 4.535 0 0 1 4.55-4.55h11.6L45 32.883l-4.638-8.05a4.56 4.56 0 0 1 1.675-6.225 4.56 4.56 0 0 1 6.226 1.674zM32.7 72.408l-4.375 7.587c-1.25 2.188-4.037 2.925-6.225 1.675s-2.925-4.038-1.675-6.225l3.25-5.625c3.675-1.137 6.662-.262 9.025 2.588m37.675-13.763h11.838a4.535 4.535 0 0 1 4.55 4.55 4.535 4.535 0 0 1-4.55 4.55h-6.575l4.437 7.7A4.56 4.56 0 0 1 78.4 81.67a4.56 4.56 0 0 1-6.225-1.675C64.7 67.032 59.088 57.333 55.363 50.87c-3.813-6.575-1.088-13.175 1.6-15.412 2.987 5.125 7.45 12.862 13.412 23.187"
    />
  </svg>
)
export default SvgReviewSourceAppStore
